Monitoring.Views ||= {}

class Monitoring.Views.MovistarActionsEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_actions_edit"]

  events:
    'click #action-tags-none': 'onClickActionTagsNone'
    'click #action-tags-remove-all': 'onClickActionTagsRemoveAll'
    'click #action-tags-remove-filtered': 'onClickActionTagsRemoveFiltered'

    'click #action-automatic-responses-none': 'onClickActionAutomaticResponsesNone'
    'click #action-automatic-responses-suspend': 'onClickActionAutomaticResponsesSuspend'
    'click #action-automatic-responses-replace': 'onClickActionAutomaticResponsesReplace'
    'change #automatic-responses-replacement': 'onChangeAutomaticResponsesReplacement'


  initialize: (@options = {}) ->
    @movistarAction = @options.movistarAction

  render: =>
    @$el.html(@template(@))
    @updateCheckboxes()
    @updateTextareaStatus()
    @

  getActions: ->
    [@movistarAction]

  onClickActionTagsNone: (evt) =>
    @movistarAction.remove_all_tags = false
    @movistarAction.remove_all_filtered_tags = false
    true

  onClickActionTagsRemoveAll: (evt) =>
    @movistarAction.remove_all_tags = true
    @movistarAction.remove_all_filtered_tags = false
    true

  onClickActionTagsRemoveFiltered: (evt) =>
    @movistarAction.remove_all_tags = false
    @movistarAction.remove_all_filtered_tags = true
    true

  onClickActionAutomaticResponsesNone: (evt) =>
    @movistarAction.suspend_automatic_responses = false
    @movistarAction.replace_automatic_responses = false
    @updateTextareaStatus()

  onClickActionAutomaticResponsesSuspend: (evt) =>
    @movistarAction.suspend_automatic_responses = true
    @movistarAction.replace_automatic_responses = false
    @updateTextareaStatus()

  onClickActionAutomaticResponsesReplace: (evt) =>
    @movistarAction.suspend_automatic_responses = false
    @movistarAction.replace_automatic_responses = true
    @updateTextareaStatus()

  onChangeAutomaticResponsesReplacement: (evt) =>
    @movistarAction.automatic_responses_replacement = $(evt.currentTarget).val()

  updateCheckboxes: =>
    if @movistarAction.remove_all_tags == true
      @$el.find('#action-tags-remove-all').prop('checked', true)
    else if @movistarAction.remove_all_filtered_tags == true
      @$el.find('#action-tags-remove-filtered').prop('checked', true)
    else
      @$el.find('#action-tags-none').prop('checked', true)

    if @movistarAction.suspend_automatic_responses == true
      @$el.find('#action-automatic-responses-suspend').prop('checked', true)
    else if @movistarAction.replace_automatic_responses == true
      @$el.find('#action-automatic-responses-replace').prop('checked', true)
    else
      @$el.find('#action-automatic-responses-none').prop('checked', true)

  updateTextareaStatus: =>
    if @movistarAction.replace_automatic_responses == true
      @$el.find('#automatic-responses-replacement').css({visibility: 'visible'})
    else
      @$el.find('#automatic-responses-replacement').css({visibility: 'hidden'})

  allMandatoryFieldsAreFilled: =>
    true
